/**
 * Basic Registration selector functions
 */
import { createSelector } from 'reselect';

const basicRegistrationReducer = (state) =>
  state.get('basicRegistrationReducer');

/**
 * Retrieves error state from basic registration reducer
 */
export const errorSelector = createSelector(basicRegistrationReducer, (state) =>
  state.get('error'),
);

/**
 * Retrieves access token state from basic registration reducer
 */
export const validAccessTokenSelector = createSelector(
  basicRegistrationReducer,
  (state) => state.get('validAccessToken'),
);

/**
 * Retrieves loading state from basic registration reducer
 */
export const loadingSelector = createSelector(
  basicRegistrationReducer,
  (state) => state.get('loading'),
);

/**
 * Retrieves influencer state from basic registration reducer
 */
export const influencerSelector = createSelector(
  basicRegistrationReducer,
  (state) => state.get('influencer'),
);

/**
 * Retrieves influencer state from basic registration reducer
 */
export const tokenSelector = createSelector(basicRegistrationReducer, (state) =>
  state.get('token'),
);
